import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _callSuper from "@babel/runtime/helpers/esm/callSuper";
import _inherits from "@babel/runtime/helpers/esm/inherits";
var _dec, _class, _AlignmentWidget;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import t from 'format-message';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { Button, IconButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { IconArrowOpenEndLine, IconArrowOpenDownLine, IconOutcomesLine, IconPlusLine } from '@instructure/ui-icons';
import { List } from '@instructure/ui-list';
import { withStyle, jsx } from '@instructure/emotion';
import OutcomePickerModal from "../OutcomePickerModal/index.js";
import AlignmentItem from "../AlignmentItem/index.js";
import AlignmentCount from "../AlignmentCount/index.js";
import { outcomeShape, stylesShape } from "../../store/shapes.js";
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
var AlignmentWidget = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_AlignmentWidget = /*#__PURE__*/function (_React$Component) {
  function AlignmentWidget(props) {
    var _this;
    _classCallCheck(this, AlignmentWidget);
    _this = _callSuper(this, AlignmentWidget, [props]);
    _this.toggleAlignmentList = function () {
      _this.setState(function (prevState) {
        return {
          renderCollapsed: !prevState.renderCollapsed
        };
      });
    };
    _this.renderHeader = function () {
      var _this$props = _this.props,
        canManageOutcomes = _this$props.canManageOutcomes,
        alignedOutcomes = _this$props.alignedOutcomes;
      var renderCollapsed = _this.state.renderCollapsed;
      var enableToggleAction = alignedOutcomes.length > 0;
      if (canManageOutcomes || alignedOutcomes.length) {
        return jsx("div", {
          css: _this.props.styles.line,
          "data-automation": "outcomeLabel__alignedOutcomes",
          style: {
            alignItems: 'center'
          }
        }, jsx(Text, {
          size: "medium"
        }, jsx("div", {
          css: _this.props.styles.spacing
        }, jsx("span", {
          style: {
            paddingRight: '0.5em'
          }
        }, jsx(IconButton, {
          size: "small",
          screenReaderLabel: renderCollapsed ? t('Expand the list of aligned Outcomes') : t('Collapse the list of aligned Outcomes'),
          withBackground: false,
          withBorder: false,
          interaction: enableToggleAction ? 'enabled' : 'disabled',
          onClick: _this.toggleAlignmentList,
          "data-automation": "alignmentWidget__collapseButton"
        }, renderCollapsed ? jsx(IconArrowOpenEndLine, {
          "data-testid": "icon-arrow-right"
        }) : jsx(IconArrowOpenDownLine, {
          "data-testid": "icon-arrow-down"
        }))), jsx(IconOutcomesLine, null))), jsx(Text, {
          size: "medium"
        }, jsx("div", {
          css: _this.props.styles.spacing
        }, t('Aligned Outcomes'), " \xA0", jsx(AlignmentCount, {
          count: alignedOutcomes.length
        }))));
      }
    };
    _this.renderAlignmentList = function () {
      if (_this.state.renderCollapsed) {
        return;
      }
      var _this$props2 = _this.props,
        alignedOutcomes = _this$props2.alignedOutcomes,
        canManageOutcomes = _this$props2.canManageOutcomes,
        features = _this$props2.features;
      return jsx(List, {
        isUnstyled: true,
        margin: "small 0"
      }, alignedOutcomes.length > 0 && jsx(List.Item, {
        key: "delimiter-0"
      }, jsx("div", null)), alignedOutcomes.map(function (outcome, index) {
        return jsx(List.Item, {
          padding: "0 small 0 medium",
          key: outcome.id
        }, jsx(AlignmentItem, {
          removeAlignment: function removeAlignment() {
            return _this.handleRemoveAlignment(outcome, index);
          },
          outcome: outcome,
          canManageOutcomes: canManageOutcomes,
          shouldFocus: index === _this.state.focusedItem,
          features: features
        }));
      }), alignedOutcomes.length > 0 && jsx(List.Item, {
        key: "delimiter-1"
      }, jsx("div", null)));
    };
    _this.renderTray = function () {
      var _this$props3 = _this.props,
        pickerProps = _this$props3.pickerProps,
        scope = _this$props3.scope,
        OutcomeTray = _this$props3.tray,
        liveRegion = _this$props3.liveRegion,
        screenreaderNotification = _this$props3.screenreaderNotification,
        showAlert = _this$props3.showAlert,
        features = _this$props3.features;
      return jsx(OutcomeTray, Object.assign({
        screenreaderNotification: screenreaderNotification,
        liveRegion: liveRegion,
        scope: scope,
        shouldModifyArtifact: true,
        showAlert: showAlert,
        features: features
      }, pickerProps));
    };
    _this.renderButton = function () {
      var _this$props4 = _this.props,
        openOutcomePicker = _this$props4.openOutcomePicker,
        canManageOutcomes = _this$props4.canManageOutcomes;
      if (canManageOutcomes) {
        return jsx("div", {
          css: _this.props.styles.button
        }, jsx(Button, {
          ref: function ref(d) {
            _this.align = d;
          } // eslint-disable-line immutable/no-mutation
          ,
          renderIcon: IconPlusLine,
          onClick: openOutcomePicker,
          "data-automation": "alignmentWidget__button"
        }, jsx(AccessibleContent, {
          alt: t('Align Outcomes'),
          "data-automation": "alignmentWidget__AccessibleContent"
        }, t('Outcome'))));
      }
    };
    _this.state = {
      renderCollapsed: true,
      focusedItem: null
    };
    return _this;
  }
  _inherits(AlignmentWidget, _React$Component);
  return _createClass(AlignmentWidget, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var alignedOutcomes = this.props.alignedOutcomes;
      if (oldProps.alignedOutcomes.length && !alignedOutcomes.length) {
        if (this.align) {
          this.align.focus();
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var alignedOutcomes = this.props.alignedOutcomes;
      if (alignedOutcomes.length === 0) {
        this.setState({
          renderCollapsed: true
        });
      }
    }
  }, {
    key: "handleRemoveAlignment",
    value: function handleRemoveAlignment(removedOutcome, index) {
      var _this$props5 = this.props,
        removeAlignment = _this$props5.removeAlignment,
        onUpdate = _this$props5.onUpdate,
        alignedOutcomes = _this$props5.alignedOutcomes;
      removeAlignment(removedOutcome.id, onUpdate, true);
      this.props.screenreaderNotification(t('{label} alignment removed', {
        label: removedOutcome.label
      }));
      var priorIndex = index - 1;
      if (priorIndex >= 0) {
        this.setState({
          focusedItem: priorIndex
        });
      } else if (alignedOutcomes.length > 0) {
        var nextIndex = index + 1;
        if (nextIndex < alignedOutcomes.length) {
          this.setState({
            focusedItem: nextIndex
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, this.renderHeader(), this.renderAlignmentList(), this.renderButton(), this.renderTray());
    }
  }]);
  AlignmentWidget.displayName = "AlignmentWidget";
}(React.Component), _AlignmentWidget.propTypes = {
  alignedOutcomes: PropTypes.arrayOf(outcomeShape).isRequired,
  pickerProps: PropTypes.object,
  scope: PropTypes.string.isRequired,
  tray: PropTypes.elementType.isRequired,
  openOutcomePicker: PropTypes.func.isRequired,
  removeAlignment: PropTypes.func.isRequired,
  onUpdate: PropTypes.func,
  screenreaderNotification: PropTypes.func,
  liveRegion: OutcomePickerModal.propTypes.liveRegion,
  canManageOutcomes: PropTypes.bool.isRequired,
  showAlert: PropTypes.func,
  features: PropTypes.array,
  styles: stylesShape
}, _AlignmentWidget.defaultProps = {
  alignedOutcomes: [],
  pickerProps: {},
  onUpdate: null,
  screenreaderNotification: null,
  liveRegion: null,
  canManageOutcomes: true,
  showAlert: function showAlert() {},
  features: []
}, _AlignmentWidget)) || _class);
export { AlignmentWidget as default };